import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../config/axiosApi/axiosApi.jsx";
import Preloader from "../../components/CustomComponents/preLoad/preLoader.js";
import APIs from "../../Constants/apis.js";
import showErrorToast, { showSuccessToast } from "../../components/CustomComponents/toast/toast.js";
import MarketplaceRiderForm from "./marketplaceRiderForm.jsx";

const AddMarketplaceRider = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (payload) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(APIs.POST_UPSERT_MARKETPLACE_RIDER, payload);
      if (response.data?.status) {
        showSuccessToast("Rider created");
        navigate("/marketplaceRider/manageRiders");
      } else {
        showErrorToast(response.data?.message || response.data?.Message || "Save failed");
      }
    } catch (err) {
      showErrorToast(err.response?.data?.message || err.response?.data?.Message || "Save failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && <Preloader />}

      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
            <li className="breadcrumb-item"><Link to="/marketplaceRider/manageRiders">Go Fatafat Riders</Link></li>
            <li className="breadcrumb-item active">Add Rider</li>
          </ol>
          <h1 className="page-header mb-0">Add Rider</h1>
          <p className="text-muted mb-0 mt-1">Create a Go Fatafat rider profile, documents, and service area.</p>
        </div>
      </div>

      <div className="card border-0">
        <div className="card-body p-3 p-md-4">
          <MarketplaceRiderForm
            onSubmit={handleSubmit}
            onCancel={() => navigate("/marketplaceRider/manageRiders")}
            submitting={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default AddMarketplaceRider;
